import Headings from '@/components/heading/Headings';
import Container from '@/components/layout/Container';

export default async function TitleAndText({ block, position }) {
  const { title, description, _metadata } = await block.title_and_text;

  const { uid } = _metadata;

  return (
    <section
      id={uid + '_' + position}
      data-name="title-and-text"
      className={`standard-padding bg-white`}
    >
      <Container>
        <div className="mx-auto max-w-3xl px-12 text-center">
          {title && (
            <Headings headingContent={title} headingClassName="h4 sm:h2 mb-8" />
          )}
          {description && <p className="body-l">{description}</p>}
        </div>
      </Container>
    </section>
  );
}
